import React from 'react'
import { TimelineContainer } from './styles'
import { useDraggableScroll } from '~/hooks/useDraggableScroll'
import { TimelineAccordion } from '~/components/shared'

interface ISection {
  title: string
  content: JSX.Element
}

export interface TimelineSectionsProps {
  sections: ISection[]
}

export const TimelineSections = ({ sections }: TimelineSectionsProps): JSX.Element => {
  const ref = React.useRef<HTMLDivElement>(null)
  const { onMouseDown } = useDraggableScroll(ref, { direction: 'vertical' })

  return (
    <TimelineContainer ref={ref} onMouseDown={onMouseDown}>
      {sections.map(section => {
        return <TimelineAccordion key={section.title} title={section.title} content={section.content} />
      })}
    </TimelineContainer>
  )
}
